import { content, HydrationHelper } from "core/utils";
import React, { useState } from "react";
import { Auth } from "common/Auth";
import { ErrorBanner } from "./components/ErrorBanner";
export var Banner = function () {
    var authMessage = Auth.Message.use();
    var _a = useState(authMessage), message = _a[0], setMessage = _a[1];
    var safeMessage = HydrationHelper.useComplete() ? message : "Nothing";
    var onClose = function () { return setMessage("Nothing"); };
    switch (safeMessage) {
        case "AuthError":
            return (React.createElement(ErrorBanner, { onClose: onClose }, content.banner.error));
        case "Nothing":
            return null;
    }
};
